import React, { useEffect } from "react";
import "./carousel.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import aos from "aos";
import "aos/dist/aos.css";

const openLink = (url) => {
  window.open(url, "_blank");
};

const data = [
  {
    name: "Ajeesh Rawal",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730703/ajeesh_cicc9a.png",
    review: "Core Lead",
    link: ["https://www.linkedin.com/in/ajeeshrawal376/"],
  },
  {
    name: "Rashmi Mishra",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730703/rashmi_e76kgz.png",
    review: "Core Lead",
    link: ["https://www.linkedin.com/in/rashmi-mishra-26732a261/"],
  },
  {
    name: "Shubh Agarwal",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730704/shubh_wnqkxh.png",
    review: "Head of Finance & Infrastructure",
    link: ["https://www.linkedin.com/in/shubhagarwal0704/"],
  },
  {
    name: "Satyagya Singh",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730704/satyagya_ubnc0c.png",
    review: "Head of Finance & Infrastructure",
    link: ["https://www.linkedin.com/in/satyagyasingh/"],
  },
  {
    name: "Prashant Kumar Gupta",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730703/prashant_m463ax.png",
    review: "Head of Teams & Competitions",
    link: ["https://www.linkedin.com/in/prashant3033/"],
  },
  {
    name: "Vaibhav Pandey",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730704/vaibhav_zfrtwf.png",
    review: "Head of PR & Events",
    link: ["https://www.linkedin.com/in/parth-agarwal-46b39635b/"],
  },
  {
    name: "Parth Agarwal",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730703/parth_qhtvdb.png",
    review: "Head of PR & Events",
    link: ["https://www.linkedin.com/in/parth-agarwal-46b39635b/"],
  },
  {
    name: "Ayush Agrawal",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730702/ayush_asqcr9.png",
    review: "Head of PR & Events",
    link: ["https://www.linkedin.com/in/ayushagr91/"],
  },

  {
    name: "Gamandeep Singh",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730702/gamandeep_fv396t.png",
    review: "Tech Lead",
    link: ["https://www.linkedin.com/in/gamandeep-singh-344001256/"],
  },
  {
    name: "Vaishnavi Singh",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730704/vaishnavi_e2aids.png",
    review: "Head of Design & Creatives",
    link: ["https://www.linkedin.com/in/vaishnavi-singh-945827257/"],
  },
  {
    name: "Animesh Kumar Singh",
    img: "https://res.cloudinary.com/dp6wx6vbg/image/upload/v1777730703/animesh_du2s4n.png",
    review: "Head of Design & Creatives",
    link: ["https://www.linkedin.com/in/animesh-kumar-singh-7a5497257/"],
  },
];

const settings = {
  dots: true,

  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  responsive: [
    {
      breakpoint: 950,
      settings: {
        dots: false,
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 630,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

export default function Carousel() {
  //  const [setLink] = useState('');
  useEffect(() => {
    aos.init(1800);
  }, []);
  return (
    <div className="w-3/4 m-auto" id="testimonial">
      <h1
        data-aos="fade-down"
        className="text-6xl max-md:text-4xl py-4 px-4 text-center ml-[80px] max-md:ml-0"
        style={{
          fontFamily: "cabin-sketch-regular",
          fontWeight: "400",
          fontStyle: "normal",
          color: "white",
        }}
      >
        Meet the Team
      </h1>
      <div className="mt-20" data-aos="fade-down">
        <Slider {...settings}>
          {data.map((d, index) => (
            <div key={index} className=" h-[450px] text-black rounded-xl">
              <div className="h-56 rounded-t-xl footer-contact flex justify-center items-center">
                <img
                  key={d.name}
                  src={d.img}
                  alt=""
                  className="h-44 w-44 rounded-full object-cover bg-white"
                />
              </div>

              <div className="flex flex-col justify-center items-center gap-4 p-4 font-[maiandra] rounded-xl bg-white">
                <p className="text-xl font-semibold">{d.name}</p>
                <p className="font-bold">{d.review}</p>
                <button
                  key={d.name}
                  className="footer-button hover:bg-[#17A2C9] hover:scale-110"
                  onClick={() => openLink(d.link)}
                >
                  Connect
                </button>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
